import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Modal,
  Paper,
} from '@mui/material';
import CustomTable from 'components/custom/CustomTable';
import { Cancel } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { setChangeInVehicle,vehicleUpdatedSelector } from 'redux/fleets/ducks';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles()(theme => {
  return {
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '100%',
      maxWidth: 800, // or any sensible max-width
      maxHeight: '90vh', // to allow scroll if needed
      display: 'flex',
      flexDirection: 'column',
      padding: '2rem',
      position: 'relative',
      overflow: 'visible', // let it grow with content
    },
    infoBox: {
      padding: 10,
      boxShadow: '0 2px 2px rgba(0, 0, 0, 0.3)',
      borderRadius: 5,
      transition: 'boxShadow 0.3s ease-in-out',

      '&:hover': {
        boxShadow: '0 2px 2px rgba(0, 0, 0, 0.5)',
      },
    },
    closeIcon: {
      right: 0,
      color: 'rgba(0,0,0,0.5)',
      cursor: 'pointer',

      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    buttons: {
      textTransform: 'capitalize',
      minWidth: 85,
    },
  };
});

const NAComponent = ({ val }) => {
  return <span>{val || 'N/A'}</span>;
};

const RevertVehicle = ({
  open,
  setOpen,
  data,
  setData,
  revertEventFn,
  isReverting,
  revertDate,
  setIsReverting,
  setIsPreview,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const vehicleDataHasChanged = useSelector(vehicleUpdatedSelector);

  let dispatch = useDispatch();

  const columns = useMemo(
    () => [
      {
        key: 'index',
        title: 'S/No',
        render: row => <NAComponent val={row.index} />,
        size: 80,
        enableColumnActions: false,
      },
      {
        key: 'position',
        title: 'Axle Position',
        render: row => <NAComponent val={row.position} />,
        size: 80,
        enableColumnActions: false,
      },
      {
        key: 'changes',
        title: 'Changes',
        render: row => <NAComponent val={row.changes} />,
        size: 80,
        enableColumnActions: false,
      },
    ],
    []
  );

  const handleConfirm = async () => {
    setIsReverting(true);
    // setIsPreview(false);
    await revertEventFn(revertDate);

    dispatch(setChangeInVehicle(!vehicleDataHasChanged));

    setIsReverting(false);
    setIsPreview(true);
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
    setData(null);
    setIsReverting(false);
    setIsPreview(true);
  };

  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Paper className={classes.paper} data-hook='event_history_modal'>
          {data?.length > 0 ? (
            <Box display='flex' flexDirection='column' gap={'10px'}>
              <Box display='flex' justifyContent='flex-end' mt={1}>
                <Box display='flex' justifyContent='flex-end' mt={1}>
                  <Cancel
                    className={classes.closeIcon}
                    onClick={handleClose}
                    data-hook='close_modal'
                  />
                </Box>
              </Box>
              <Box width='100%'>
                <CustomTable
                  columns={columns}
                  data={data || []}
                  pageSize={30}
                  showFooter={false}
                  isLoading={isReverting}
                  showTopToolbar={false}
                />
              </Box>
              <Box display='flex' flexDirection='column' gap={'20px'} mt={6}>
                {/* <Typography variant='h6'>
                  {t('eventHistoryModal.dialogMessage')}
                </Typography> */}
                <Box display='flex' gap={'10px'} alignSelf='center'>
                  <Button
                    variant='outlined'
                    size='small'
                    className={classes.buttons}
                    onClick={handleClose}
                    data-hook='cancel_revert'
                  >
                    {t('common.cancel')}
                  </Button>
                  <Button
                    color='primary'
                    variant='contained'
                    className={classes.buttons}
                    onClick={handleConfirm}
                    disabled={isReverting}
                    data-hook='confirm_revert'
                  >
                    {isReverting ? (
                      <CircularProgress size={30} />
                    ) : (
                      t('common.confirm')
                    )}
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : (
            <div>{t('tireInventoryItems.noData')}</div>
          )}
        </Paper>
      </Fade>
    </Modal>
  );
};

RevertVehicle.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  data: PropTypes.array,
  setData: PropTypes.func,
  isLoading: PropTypes.bool,
  setIsLoading: PropTypes.func,
  revertEventFn: PropTypes.func,
  isReverting: PropTypes.bool,
  open2: PropTypes.bool,
  setOpen2: PropTypes.func,
  setIsReverting: PropTypes.func,
  isReporter: PropTypes.bool,
};

export default RevertVehicle;
